import {memo} from "react";
import {useDraggable} from "@dnd-kit/core";
import {Box} from "@mui/material";

interface Props {
    id: string;
    data: { type: "unassigned" | "halfboard"; [key: string]: any };
    children: React.ReactNode;
}

const DraggableSidebarItem: React.FC<Props> = ({id, data, children}) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        isDragging
    } = useDraggable({
        id,
        data,
    });

    return (
        <Box
            ref={setNodeRef}
            {...listeners}
            {...attributes}
            sx={{
                opacity: isDragging ? 0.4 : 1,
                pointerEvents: isDragging ? "none" : undefined,
                touchAction: "manipulation",
                WebkitUserSelect: "none",
                userSelect: "none",
                cursor: "grab",
                "& *": {cursor: "inherit"},
                "& button, & button *": {cursor: "pointer"},
            }}
        >
            {children}
        </Box>
    );
};

export default memo(DraggableSidebarItem);
